import { ReactElement } from 'react';
import { Box, Typography } from '@mui/material';

export const HomePage = (): ReactElement => {
  return (
    <Box
      sx={{
        height: '100vh',
        width: '100vw',
        margin: 0,
        padding: 0,
        backgroundColor: 'black',
        maxWidth: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Typography
        sx={{
          fontFamily: 'LemonMilkMedium',
          fontSize: 45,
          color: 'white',
          textAlign: 'center',
        }}
      >
        Intuitive Engineering
      </Typography>
    </Box>
  );
};

export default HomePage;
